import { Carousel } from 'antd-mobile';

import { appMethod as app, appInstance } from '@utils/app';
import utils from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PresellDetail.less';

export default class PresellDetail extends OfficialPage {
  state = {
    defaultPhoto: '',
    storeStyle: '',
    imageOrVideo: 'image',
    displayComment: true,
    addToShoppingCartHidden: true,
    isStart: true,
    isPageScroll: true,
    formid: [],
    selectModelInfo: {
      models: [],
      stock: '',
      price: '',
      virtualPrice: '',
      buyCount: 1,
      models_text: '',
      discountInfo: {}
    },
    carouselCurrentIndex: 1
  }

  constructor(props) {
    super(props);
    document.title = '商品详情';
  }

  loadDetails = () => {
    var that = this,
      goodsModel = [],
      selectModels = [],
      activityArr = [],
      modelStrs = {},
      description = '',
      modifySelectModels = '',
      price = 0,
      allStock = 0,
      selectStock,
      selectPrice,
      selectModelId,
      matchResult,
      selectVirtualPrice,
      selectText = '',
      presell_status,
      start_time,
      end_time,
      selectDiscountInfo,
      i,
      j,
      disIndex,
      selectImgurl = ''
    app.sendRequest({
      url: '/index.php?r=AppPreSell/GetPreSellGoodsDetail',
      data: {
        activity_id: that.data.activity_id,
        goods_id: that.data.goods_id,
        sub_app_id: that.data.franchiseeId || ''
      },
      success: res => {
        if (!res.data.length) {
          app.showModal({
            content: '很抱歉，您查看的宝贝不存在，可能已经下架或者移除',
            confirm: function () {
              app.turnBack()
            }
          })
          return
        }
        var _presell_activity = res._presell_activity,
          goods = res.data[0].form_data,
          _presell_discount_info = goods._presell_discount_info,
          _presell_goods = goods._presell_goods
        goods.downCount = {
          hours: '00',
          minutes: '00',
          seconds: '00',
          days: '00'
        }
        description = goods.description
        for (var key in goods.model) {
          if (key) {
            var model = goods.model[key]
            goodsModel.push(model)
            if (model && model.subModelName) {
              modelStrs[model.id] = model.subModelName.join('、')
              selectModels.push(model.subModelId[0])
              modifySelectModels = selectModels.toString()
              selectText += '“' + model.subModelName[0] + '” '
            }
          }
        }
        if (goods.model_items.length) {
          var items = goods.model_items
          for (i = 0, j = items.length; i < j; i++) {
            price = items[i].price
            goods.highPrice = goods.highPrice > price ? goods.highPrice : price
            goods.lowPrice = goods.lowPrice < price ? goods.lowPrice : price
            allStock += Number(items[i].stock)
            if (i == 0) {
              selectPrice = price
              selectStock = items[0].stock
              selectModelId = items[0].id
              selectImgurl = items[i].img_url
              selectVirtualPrice =
                items[i].virtual_price != '0.00' && items[i].virtual_price
                  ? items[i].virtual_price
                  : ''
              for (
                disIndex = 0;
                disIndex < _presell_discount_info.length;
                disIndex++
              ) {
                if (
                  _presell_discount_info[disIndex].model_id == selectModelId
                ) {
                  selectDiscountInfo = _presell_discount_info[disIndex]
                }
              }
            }
          }
        } else {
          selectPrice = goods.price
          selectStock = goods.stock
          selectImgurl = goods.cover
          selectVirtualPrice =
            goods.virtual_price != '0.00' && goods.virtual_price
              ? goods.virtual_price
              : ''
          selectDiscountInfo = _presell_discount_info[0]
        }
        goods.price_inter =
          goods._presell_goods.presell_min_price ==
            goods._presell_goods.presell_max_price
            ? goods._presell_goods.presell_min_price
            : goods._presell_goods.presell_min_price +
            '~' +
            goods._presell_goods.presell_max_price
        goods.final_price_inter =
          _presell_goods.presell_min_final_payment ==
            _presell_goods.presell_max_final_payment
            ? _presell_goods.presell_min_final_payment
            : _presell_goods.presell_min_final_payment +
            '~' +
            _presell_goods.presell_max_final_payment
        goods.model = goodsModel
        start_time = _presell_activity.bargain_start_time * 1
        end_time = _presell_activity.bargain_end_time * 1
        goods.server_time = goods.server_time || Date.parse(new Date()) / 1000
        goods.start_time = utils.formatTime(new Date(start_time * 1000))
        goods.end_time = utils.formatTime(new Date(end_time * 1000))
        goods.presell_status =
          end_time > goods.server_time
            ? start_time * 1 > goods.server_time
              ? '0'
              : '1'
            : '2'
        goods.final_payment_start_time = utils.formatTimeYMD(
          new Date(_presell_activity.final_payment_start_time * 1000),
          'M月DD日 hh:mm'
        )
        goods.final_payment_end_time = utils.formatTimeYMD(
          new Date(_presell_activity.final_payment_end_time * 1000),
          'M月DD日 hh:mm'
        )
        if (goods.presell_status == 0) {
          that.downcount = that.beforeDownCount(goods, res.data, that, 'goods')
        } else if (goods.presell_status == 1) {
          that.downcount = that.duringDownCount(goods, that, 'goods')
        }
        description = description
          ? description.replace(/\u00A0|\u2028|\u2029|\uFEFF/g, '')
          : description
        goods.description = description
        goods.virtual_price =
          goods.virtual_price == '0.00' && goods.virtual_price
            ? ''
            : goods.virtual_price
        that.setData({
          'selectModelInfo.models': selectModels || '',
          'selectModelInfo.stock': selectStock || '',
          'selectModelInfo.price': selectPrice || '',
          'selectModelInfo.modelId': selectModelId || '',
          'selectModelInfo.discountInfo': selectDiscountInfo || '',
          'selectModelInfo.models_text': selectText || '',
          'selectModelInfo.imgurl': selectImgurl || '',
          'selectModelInfo.virtualPrice': selectVirtualPrice || '',
          goods: goods
        })
        that.getAssessList(0, 1)
      }
    })
  }
  getAssessList = (commnetType, page, append) => {
    var that = this
    app.getAssessList({
      method: 'post',
      data: {
        goods_id: that.data.goods_id,
        idx_arr: {
          idx: 'level',
          idx_value: commnetType
        },
        page: page,
        page_size: 20,
        sub_shop_app_id: this.data.franchiseeId || ''
      },
      success: function (res) {
        var commentData = res.data
        if (append) {
          commentData = that.data.commentArr.concat(commentData)
        }
        that.setData({
          commentArr: commentData,
          commentNums: res.num,
          commentPage: that.data.commentPage + 1,
          commentExample: res.data[0] || '',
          commentTotalPage: res.total_page,
          displayComment: +res.num[0] > 0 ? false : true,
          'rect[2].isShow': +res.num[0] > 0
        })
      }
    })
  }
  beforeDownCount = (formData, res, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.start_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.presell_status'] = 1
          newData[path + '.server_time'] = formData.start_time
          page.setData(newData)
          page.loadDetails()
          formData.server_time = formData.start_time
          if (res.end_date != '-1') {
            _this.downcount = _this.duringDownCount(formData, page, path)
          }
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  duringDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.end_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.presell_status'] = 2
          page.setData(newData)
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  paymentDeposit = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
    this.setData({
      addToShoppingCartHidden: false,
      ifAddToShoppingCart: false,
      isPageScroll: false,
      imageOrVideo: 'image'
    })
  }
  buyDirectlyNextStep = e => {
    let that = this
    if (!app.isLogin()) {
      app.goLogin({
        success: function () {
          that.buyDirectlyNextStep(e)
        }
      })
      return
    }
    let franchiseeId = that.data.franchiseeId,
      param = {
        goods_id: that.data.goods_id || '',
        activity_id: that.data.activity_id || '',
        model_id: that.data.selectModelInfo.modelId || '',
        nums: that.data.selectModelInfo.buyCount || 1,
        sub_shop_app_id: franchiseeId || '',
        final_payment_start_time:
          that.data.goods.final_payment_start_time || '',
        address_id: '',
        type: '1',
        models_text: that.data.selectModelInfo.models_text,
        models_stock:
          that.data.selectModelInfo.discountInfo.presell_stock_left ||
          that.data.goods._presell_discount_info[0].presell_stock_left,
        bargain_order_id: '',
        presell_status: 1,
        limit_buy: that.data.selectModelInfo.discountInfo.buy_limit_num || ''
      },
      buyer_num = that.data.goods._presell_goods.buyer_num,
      pagePath =
        '/presell/pages/previewPresellOrder/previewPresellOrder?param=' +
        encodeURIComponent(JSON.stringify(param))
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
    if (param.limit_buy && param.nums > param.limit_buy - buyer_num) {
      app.showModal({
        content: '您已买' + buyer_num + '件，每人限购' + param.limit_buy + '件'
      })
      return
    }
    if (param.nums > param.models_stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      return
    }
    that.hiddeAddToShoppingCart()
    that.saveUserFormId(pagePath, 0)
  }
  selectSubModel = e => {
    var dataset = e.currentTarget.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModelsInfo = this.data.selectModelInfo,
      selectModels = this.data.selectModelInfo.models,
      model = this.data.goods.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['selectModelInfo.models'] = selectModels
    data['selectModelInfo.models_text'] = text
    data['selectModelInfo.buyCount'] = 1
    this.setData(data)
    this.resetSelectCountPrice()
  }
  resetSelectCountPrice = () => {
    var selectModelIds = this.data.selectModelInfo.models.join(','),
      modelItems = this.data.goods.model_items,
      discountInfo = this.data.goods._presell_discount_info,
      discountInfoArr = [],
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model) {
        if (modelItems[i].model == selectModelIds) {
          data['selectModelInfo.stock'] = modelItems[i].stock
          data['selectModelInfo.virtualPrice'] =
            modelItems[i].virtual_price != '0.00' && modelItems[i].virtual_price
              ? modelItems[i].virtual_price || ''
              : ''
          data['selectModelInfo.price'] = modelItems[i].price
          data['selectModelInfo.modelId'] = modelItems[i].id || ''
          data['selectModelInfo.imgurl'] = modelItems[i].img_url || ''
          for (var disIndex = 0; disIndex < discountInfo.length; disIndex++) {
            if (discountInfo[disIndex].model_id == modelItems[i].id) {
              data['selectModelInfo.discountInfo'] = discountInfo[disIndex]
            }
          }
          break
        }
      }
    }
    this.setData(data)
  }
  clickMinusButton = e => {
    var count = this.data.selectModelInfo.buyCount
    if (count <= 1) {
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count - 1
    })
  }
  clickPlusButton = e => {
    var selectModelInfo = this.data.selectModelInfo,
      limit_buy = +this.data.selectModelInfo.discountInfo.buy_limit_num,
      count = selectModelInfo.buyCount,
      buyer_num = +this.data.goods._presell_goods.buyer_num,
      stock = +selectModelInfo.discountInfo.presell_stock_left
    if (limit_buy && count >= limit_buy) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      this.setData({
        'selectModelInfo.buyCount': limit_buy
      })
      return
    }
    if (limit_buy && count >= limit_buy - buyer_num) {
      app.showModal({
        content: '您已买' + buyer_num + '件，每人限购' + limit_buy + '件'
      })
      this.setData({
        'selectModelInfo.buyCount': limit_buy - buyer_num
      })
      return
    }
    if (count >= stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      this.setData({
        'selectModelInfo.buyCount': stock
      })
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count + 1
    })
  }
  inputBuyCount = e => {
    var count = +e.target.value,
      selectModelInfo = this.data.selectModelInfo,
      stock = +selectModelInfo.discountInfo.presell_stock_left,
      limit_buy = +this.data.selectModelInfo.discountInfo.buy_limit_num,
      buyer_num = +this.data.goods._presell_goods.buyer_num
    if (count > limit_buy && limit_buy != 0) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      this.setData({
        'selectModelInfo.buyCount': +limit_buy
      })
      return
    }
    if (limit_buy && count >= limit_buy - buyer_num) {
      app.showModal({
        content: '您已买' + buyer_num + '件，每人限购' + limit_buy + '件'
      })
      this.setData({
        'selectModelInfo.buyCount': limit_buy - buyer_num
      })
      return
    }
    if (count >= stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      this.setData({
        'selectModelInfo.buyCount': stock
      })
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count
    });
  }
  blurBuyCount = e => {
    var value = +e.target.value
    if (isNaN(value) || value <= 0) {
      app.showToast({
        title: '最少购买一件哦！',
        icon: 'none'
      })
      this.setData({
        'selectModelInfo.buyCount': 1
      })
      return
    }
  }
  clickPlusImages = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src,
      urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
    })
  }
  carouselIndex = event => {
    this.setData({
      carouselCurrentIndex: event.target.current + 1
    })
  }
  goToHomepage = () => {
    let that = this
    let franchiseeId = that.data.franchiseeId
    let chainId = app.getChainId()
    if (franchiseeId && franchiseeId != chainId) {
      let pages = app.getCurrentPages()
      let p = pages[pages.length - 2]
      if (!p) {
        app.sendRequest({
          url: '/index.php?r=AppShop/GetAppShopByAppId',
          data: {
            parent_app_id: app.getAppId(),
            sub_app_id: franchiseeId
          },
          success: function (res) {
            let data = res.data
            if (data) {
              let mode = data.mode_id
              let param = {}
              param.detail = franchiseeId
              if (data.audit == 2) {
                param.shop_id = data.id
              }
              app.goToFranchisee(mode, param, true)
            }
          }
        })
      } else if (p.route == 'franchisee/pages/goodsMore/goodsMore') {
        app.turnBack({
          delta: 2
        })
      } else {
        app.turnBack()
      }
    } else {
      var router = app.getHomepageRouter()
      app.reLaunch({
        url: '/pages/' + router + '/' + router
      })
    }
  }
  goToCommentPage = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/goodsComment/goodsComment?detail=' +
        this.data.goods_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    this.saveUserFormId(pagePath, 0)
  }
  showQRCodeComponent = () => {
    let that = this
    let goodsInfo = this.data.goods
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=AppPreSell/GetShareQRCode',
      data: {
        goods_id: that.data.goods_id,
        sub_app_id: that.data.franchiseeId || ''
      },
      success: function (res) {
        // animation.bottom('0').step()
        // that.setData({
        //   'pageQRCodeData.shareDialogShow': 0,
        //   'pageQRCodeData.shareMenuShow': true,
        //   'pageQRCodeData.goodsInfo': res.data,
        //   'pageQRCodeData.animation': animation.export()
        // })
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data
          }
        });
      }
    })
  }
  hiddeAddToShoppingCart = () => {
    this.setData({
      addToShoppingCartHidden: true,
      isPageScroll: true
    })
  }
  addFavoriteGoods = event => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addFavoriteGoods',
      data: {
        form_id: event.target.formId,
        goods_id: _this.data.goods_id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          'goods.is_favorite': 1
        })
      },
      complete: function () {
        app.showToast({
          title: '收藏成功!',
          image: '/images/favorites.png'
        })
      }
    })
  }
  deleteFavoriteGoods = event => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteFavoriteGoods',
      method: 'post',
      data: {
        goods_id_arr: [_this.data.goods_id],
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          'goods.is_favorite': 0
        })
      },
      complete: function () {
        app.showToast({
          title: '取消收藏!',
          image: '/images/cancel-favorites.png'
        })
      }
    })
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = (path, isRedirect) => {
    app.showLoading({
      title: '加载中'
    })
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchiseeId || '',
        form_id: _this.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        app.turnToPage(path, isRedirect)
        _this.setData({
          formid: []
        })
      }
    })
  }
  changeImageOrVideo = event => {
    this.setData({
      videoPoster: false,
      imageOrVideo: event.currentTarget.dataset.type
    })
  }
  startPlayVideo = () => {
    let video = app.createVideoContext('carousel-video')
    this.setData({
      videoPoster: true
    })
    video.play()
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      goods_id: options.detail || '',
      franchiseeId: options.franchisee || ''
    })
    this.loadDetails()
  }

  onShareAppMessage = () => {
    this.setData({
      pageQRCodeData: {
        shareDialogShow: '100%',
        shareMenuShow: false
      }
    })
    let that = this,
      goodsid = this.data.goods_id,
      franchiseeId = this.data.franchiseeId,
      title = this.data.goods.share_title || this.data.goods.title,
      shareImage = this.data.goods.share_img || this.data.goods.cover,
      path =
        '/presell/pages/presellDetail/presellDetail?detail=' +
        goodsid +
        (franchiseeId ? '&franchisee=' + franchiseeId : '') +
        (app.globalData.pageShareKey
          ? '&psid=' + app.globalData.pageShareKey
          : '')
    return app.shareAppMessage({
      path: path,
      title: title,
      imageUrl: shareImage
    })
  }

  render() {
    const {
      showGetUserInfo,
      pageQRCodeData,
      isPageScroll,
      goods,
      goodsInfo,
      imageOrVideo,
      videoPoster,
      selectModelInfo,
      displayComment,
      commentNums,
      commentExample,
      defaultPhoto,
      franchiseeId,
      isSeckill,
      addToShoppingCartHidden,
      storeStyle,
      priceDiscountStr,
      isShowVirtualPrice,
      ifAddToShoppingCart
    } = this.state

    return (
      <div className="official-page presell-detail">
        <TopNav title="商品详情"/>
        <React.Fragment>
          <div
            id="presell-goodsDetail"
            style={convertLineStyleData(
              isPageScroll ? '' : 'overflow:hidden;height:calc(100vh - 84rpx);'
            )}
          >
            <div className="goods-header goods-section">
              <div className="goods-cover">
                {imageOrVideo == 'image' && (
                  <div className="image-carousel-container">
                    {!(goods && goods.img_urls) ? (
                      <div className="goods-cover-container isRelative">
                        <img
                          data-src={goods && goods.cover}
                          onClick={this.clickPlusImages}
                          src={goods && goods.cover}
                          data-src={goods && goods.cover}
                          mode="aspectFill"
                        />
                      </div>
                    ) : (
                        <div className="slick-carousel-container">
                          <Carousel
                            dots={false}
                            infinite={true}
                            autoplay={true}
                            autoplayInterval={5000}>
                            {goods.img_urls.map((item, index) => {
                              return (
                                <div key={index}>
                                  <img
                                    data-src={item}
                                    data-srcarr={goods && JSON.stringify(goods.img_urls)}
                                    onClick={this.clickPlusImages}
                                    src={item}
                                    mode="aspectFit"
                                    className="slide-image"
                                  />
                                </div>
                              )
                            })}
                          </Carousel>
                        </div>
                      )}
                    {goods && goods.video_url && (
                      <div className="image-video-menu">
                        <span
                          className={imageOrVideo == 'image' ? 'active' : ''}
                          data-type="image"
                          onClick={this.changeImageOrVideo}
                        >
                          图片
                        </span>
                        <span
                          className={imageOrVideo == 'video' ? 'active' : ''}
                          data-type="video"
                          onClick={this.changeImageOrVideo}
                        >
                          视频
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {goods && goods.video_url && imageOrVideo == 'video' && (
                  <div className="video-carousel-container">
                    {videoPoster && (
                      <video src={goods.video_url} id="carousel-video">
                        {goods.video_url && (
                          <CoverView className="image-video-menu">
                            <CoverView
                              className={imageOrVideo == 'image' ? 'active' : ''}
                              data-type="image"
                              onClick={this.changeImageOrVideo}
                            >
                              图片
                            </CoverView>
                            <CoverView
                              className={imageOrVideo == 'video' ? 'active' : ''}
                              data-type="video"
                              onClick={this.changeImageOrVideo}
                            >
                              视频
                            </CoverView>
                          </CoverView>
                        )}
                      </video>
                    )}
                    <div className="videoele-cover-view" hidden={videoPoster}>
                      <div className="videoele-poster-wrap">
                        <img
                          className="videoele-poster"
                          src={goods.video_img}
                          mode="scaleToFill"
                        />
                      </div>
                      <div
                        className="videoele-play-icon"
                        onClick={this.startPlayVideo}
                      >
                        <img
                          className="videoele-play-image"
                          src="http://cdn.jisuapp.cn/static/webapp/images/play.png"
                          mode="scaleToFill"
                        />
                      </div>
                      <div className="image-video-menu">
                        <span
                          className={imageOrVideo == 'image' ? 'active' : ''}
                          data-type="image"
                          onClick={this.changeImageOrVideo}
                        >
                          图片
                        </span>
                        <span
                          className={imageOrVideo == 'video' ? 'active' : ''}
                          data-type="video"
                          onClick={this.changeImageOrVideo}
                        >
                          视频
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="goods-tabbar"
                style={convertLineStyleData(
                  'background: ' +
                  (goods && goods.presell_status != 0
                    ? 'rgba(255, 179, 188, .29)'
                    : 'rgba(190, 146, 255, .29)')
                )}
              >
                <img
                  src={
                    'http://cdn.jisuapp.cn/static/webapp/images/presell/' +
                    (goods && goods.presell_status != 0 ? 'price-bar2' : 'price-bar1') +
                    '.png'
                  }
                />
                <div style={convertLineStyleData('position:absolute;top:0;left:0;')}>
                  <div className="presell-price">
                    <div>
                      <span>定金</span>
                      <span>¥</span>
                      <span>{selectModelInfo.discountInfo.bargain}</span>
                    </div>
                    {goods && goods.presell_status != 0 && (
                      <span className="sales-num">
                        {'已售' +
                          (goods && goods._presell_goods && goods._presell_goods.bargain_payment_count) +
                          '件'}
                      </span>
                    )}
                  </div>
                  {goods && goods.presell_status == 0 ? (
                    <div className="count-down preview-presell">
                      <div className="remain-tip">
                        <span>距预售开始</span>
                        <span>:</span>
                      </div>
                      <div className="remain-time">
                        <span>{goods.downCount.days}</span>
                        <span>天</span>
                        <span>{goods.downCount.hours}</span>
                        <span>:</span>
                        <span>{goods.downCount.minutes}</span>
                        <span>:</span>
                        <span>{goods.downCount.seconds}</span>
                      </div>
                    </div>
                  ) : (
                      goods && goods.presell_status == 1 && (
                        <div className="count-down start-presell">
                          <div className="remain-tip">
                            <span>距预售结束</span>
                            <span>:</span>
                          </div>
                          <div className="remain-time">
                            <span>{goods.downCount.days}</span>
                            <span>天</span>
                            <span>{goods.downCount.hours}</span>
                            <span>:</span>
                            <span>{goods.downCount.minutes}</span>
                            <span>:</span>
                            <span>{goods.downCount.seconds}</span>
                          </div>
                        </div>
                      )
                    )}
                </div>
              </div>
              <div className="goods-infor">
                <div className="goods-title">
                  <div className="text">{goods && goods.title}</div>
                  <div
                    className="share-jbtn isRelative"
                    onClick={this.showQRCodeComponent}
                  >
                    <span className="ico-moon icon-news-sharefriends"></span>
                  </div>
                </div>
                <div className="goods-price">
                  <div
                    className={
                      'first-price ' +
                      (goods && goods.presell_status == 1
                        ? 'start-presell'
                        : 'preview-presell')
                    }
                  >
                    <span>{'¥ ' + (goods ? goods.price_inter : '')}</span>
                    <span className="price-tip">预售价</span>
                  </div>
                  <div className="final-price">
                    <span>尾款 :</span>
                    <span>{'¥ ' + (goods ? goods.final_price_inter: '')}</span>
                    <span>
                      {'(' +
                        (goods ? goods.final_payment_start_time : '') +
                        ' ~ ' +
                        (goods ? goods.final_payment_end_time : '') +
                        ')'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="goods-express goods-section">
              {'运费 : ' + (goods ? goods.express_fee : '')}
            </div>
            <div className="goods-flow goods-section">
              <div className="flow-tip isRelative">
                <span>流程</span>
                <span className="ico-moon icon-rightarrow"></span>
              </div>
              <div className="flow-play">
                <div>
                  <span
                    className="ico-moon icon-presell-handsel"
                    style={convertLineStyleData('padding-left:4rpx;')}
                  ></span>
                  <span>付定金</span>
                </div>
                <div>
                  <span className="ico-moon icon-fillet-rectangle"></span>
                </div>
                <div>
                  <span
                    className="ico-moon icon-presell-surplus"
                    style={convertLineStyleData('padding-left:4rpx;')}
                  ></span>
                  <span>付尾款</span>
                </div>
                <div>
                  <span className="ico-moon icon-fillet-rectangle"></span>
                </div>
                <div>
                  <span className="ico-moon icon-presell-consign"></span>
                  <span>发货</span>
                </div>
              </div>
            </div>
            <div className="shop-message goods-section">
              <div className="goods-shop-info">
                <div className="image-wrap">
                  <img src={goods && goods.app_cover} />
                </div>
                <div className="shop-info">
                  <div className="app-name">{(goods && goods.app_name) || ''}</div>
                  <div className="sales-num">
                    在售<span style={convertLineStyleData('color:#909090;margin:0 10rpx;')}>|</span>
                    <span>
                      {(goods && goods._presell_goods && goods._presell_goods.onsale_goods_count) || (goods && goods.sales)}
                    </span>
                    件商品
                  </div>
                </div>
              </div>
              <div
                className="goods-shop-into isRelative"
                onClick={this.goToHomepage}
              >
                进入店铺
              </div>
            </div>
            <div
              className="comment-message  goods-section"
              hidden={displayComment}
              id="comment"
            >
              <div className="comment-title">
                <div>{'晒单评价 (' + ((commentNums && commentNums[0]) || 0) + ')'}</div>
                <div onClick={this.goToCommentPage} className="isRelative">
                  <span>查看全部</span>
                  <span className="ico-moon icon-rightarrow"></span>
                </div>
              </div>
              <div className="block-item">
                {!!commentExample && (
                  <div>
                    <div className="comment-item">
                      <div>
                        <img
                          className="comment-user-photo"
                          src={commentExample.buyer_headimgurl || defaultPhoto}
                        />
                        <div>
                          <span className="commentPersonName">
                            {commentExample.buyer_nickname}
                          </span>
                          <div className="comment-date">
                            {commentExample.add_time}
                          </div>
                        </div>
                      </div>
                      <div className="comment-content">
                        {commentExample.assess_info.content}
                      </div>
                      {!!commentExample.assess_info.has_img && (
                        <div className="comPage-comment-pics">
                          {commentExample.assess_info.img_arr.map(
                            (imgSrc, index) => {
                              return (
                                <img
                                  key={index}
                                  src={imgSrc}
                                  data-src={imgSrc}
                                  data-srcarr={JSON.stringify(commentExample.assess_info.img_arr)}
                                  onClick={this.clickPlusImages}
                                />
                              )
                            }
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="goods-detail-section goods-section" id="detail">
              <div className="goodsDetail-title isRelative">
                商品详情
              </div>
              <div className="goods-details rich-text" dangerouslySetInnerHTML={{__html: goods && goods.description && goods.description.replace(/href=".*?"/g,'')}}></div>
            </div>
            <div className="goods-bottom">
              <div className="anthor-btn">
                {!franchiseeId && (
                  <div className="form-contain goods-opt-item flex-sub-box-3">
                    <form>
                      <button
                        type="button"
                        onClick={
                          goods && goods.is_favorite == 1
                            ? this.deleteFavoriteGoods
                            : this.addFavoriteGoods
                        }>
                        <div className="bottom-border-right">
                          <span
                            className={
                              'ico-moon icon-' +
                              (goods && goods.is_favorite == 1
                                ? 'collect-solid'
                                : 'goods-detail-favorites') +
                              ' icon-collect-cover'
                            }
                          ></span>
                          <div className="ico-text ico-text-cover">收藏</div>
                        </div>
                      </button>
                    </form>
                  </div>
                )}
                <div
                  className={
                    'goods-opt-item flex-sub-box-' +
                    (isSeckill || franchiseeId ? '2' : '3') +
                    ' isRelative'
                  }
                >
                  <div className="ico-moon icon-service2">
                    {/* <ContactButton
                      type="default-dark"
                      size="20"
                      sessionFrom="goods"
                    ></ContactButton> */}
                  </div>
                  <div className="ico-text">客服</div>
                </div>
              </div>
              <div className="group-buy-btn">
                {goods && goods.presell_status == 1 ? (
                  <div className="payment-deposit isRelative">
                    <div>
                      <div>{'¥ ' + selectModelInfo.discountInfo.bargain}</div>
                      <span>支付定金</span>
                      <form className="getFormId">
                        <button
                          type="button"
                          className="invisibleclass"
                          data-id={goods && goods.id}
                          data-orderid={goods && goods.order_id}
                          onClick={this.paymentDeposit}
                        ></button>
                      </form>
                    </div>
                  </div>
                ) : (
                    <div className="preview-presell isRelative">
                      {goods && goods.presell_status == 0 ? '未开售' : '支付定金'}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div
            id="payDialog"
            className="page-dialog-wrap"
            hidden={addToShoppingCartHidden}
          >
            <div className="page-bottom-dialog">
              <div
                className="pay-close-dialog page-dialog-close"
                onClick={this.hiddeAddToShoppingCart}
              >
                <span className="ico-moon icon-closes"></span>
              </div>
              <div className="dialog-goods-header">
                <div className="thumb">
                  <div className="thumb-wrap">
                    <img
                      data-src={selectModelInfo.imgurl || (goods && goods.cover)}
                      onClick={this.clickPlusImages}
                      className="pay-goods-cover"
                      src={selectModelInfo.imgurl || (goods && goods.cover)}
                    />
                  </div>
                </div>
                <div className="pay-goods-baseinfo">
                  <div className="pay-goods-price">
                    <div className="pay-current-price">
                      {selectModelInfo.price != '0.00' && (
                        <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                          {'定金 ¥ ' + selectModelInfo.discountInfo.bargain}
                        </span>
                      )}
                      {selectModelInfo.price != '0.00' && (
                        <span
                          style={convertLineStyleData(
                            'color:' + storeStyle.theme + ';margin-left:22rpx;'
                          )}
                        >
                          {'预售价 ¥ ' +
                            selectModelInfo.discountInfo.presell_price}
                        </span>
                      )}
                      {goods && goods.integral == '2' ? (
                        <React.Fragment>
                          {selectModelInfo.price != '0.00' &&
                            goods.max_can_use_integral != 0 && (
                              <span
                                style={convertLineStyleData(
                                  goods.goods_type != 0
                                    ? ''
                                    : 'color:' + storeStyle.theme
                                )}
                              >
                                +
                              </span>
                            )}
                          {goods.max_can_use_integral != 0 && (
                            <span
                              style={convertLineStyleData(
                                goods.goods_type != 0
                                  ? ''
                                  : 'color:' + storeStyle.theme
                              )}
                            >
                              {goods.max_can_use_integral + '积分'}
                            </span>
                          )}
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            {priceDiscountStr != '' && (
                              <span className="goods-price-discount">
                                {priceDiscountStr}
                              </span>
                            )}
                          </React.Fragment>
                        )}
                      {isShowVirtualPrice &&
                        selectModelInfo.virtualPrice != 0 &&
                        goods.goods_type != 1 && (
                          <span className="virtualPrice">
                            {'¥' + selectModelInfo.virtualPrice}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="pay-goods-stock">
                    {'库存 ' + selectModelInfo.discountInfo.presell_stock_left}
                  </div>
                  {selectModelInfo.models_text && (
                    <div className="pay-checked-text clearfix">
                      {'已选：' + selectModelInfo.models_text}
                    </div>
                  )}
                </div>
              </div>
              <div className="payDialog-content">
                <div
                  className="pay-goods-models"
                  hidden={!(goods && goods.model_items && goods.model_items.length)}
                >
                  {goods && goods.model && goods.model.map((model, modelIndex) => {
                    return (
                      <div key={modelIndex}>
                        <span className="model-title">{model.name}</span>
                        <label className="pills-list">
                          {model.subModelName.map((name, index) => {
                            return (
                              <label
                                key={index}
                                data-model-index={modelIndex}
                                data-submodel-index={index}
                                className={
                                  'subModel isRelative ' +
                                  (selectModelInfo.models[modelIndex] ==
                                    model.subModelId[index]
                                    ? 'select'
                                    : '')
                                }
                                data-submodel-id={model.subModelId[index]}
                                onClick={this.selectSubModel}
                                style={convertLineStyleData(
                                  selectModelInfo.models[modelIndex] ==
                                    model.subModelId[index]
                                    ? 'background:' + storeStyle.theme
                                    : ''
                                )}
                              >
                                {name}
                              </label>
                            )
                          })}
                        </label>
                      </div>
                    )
                  })}
                </div>
                <div
                  className="payDialog-buy-num"
                  style={convertLineStyleData('padding-left:10px;padding-right:10px;')}
                >
                  <div className="clearfix">
                    <span>购买数量 ：</span>
                    <div className="pull-right">
                      <div className="quantity pull-left">
                        <label
                          className={
                            'minus ' +
                            (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                          }
                        ></label>
                        <input
                          className="pay-buy-count"
                          type="number"
                          className="txt"
                          value={selectModelInfo.buyCount}
                          onChange={this.inputBuyCount}
                          onBlur={this.blurBuyCount}
                        />
                        <label
                          className={
                            'plus ' +
                            (selectModelInfo.buyCount >= selectModelInfo.stock ||
                              selectModelInfo.buyCount >= goods.seckill_buy_limit
                              ? 'disabled'
                              : '')
                          }
                        >
                        </label>
                        <div
                          className="response-area response-area-minus"
                          onClick={this.clickMinusButton}
                        >
                        </div>
                        <div
                          className="response-area response-area-plus isRelative"
                          onClick={this.clickPlusButton}
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dialog-bottom">
                <div hidden={ifAddToShoppingCart}>
                  <div
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    className="btn-orange pay-buy-next"
                    onClick={this.buyDirectlyNextStep}
                  >
                    确定
                  </div>
                </div>
                <div hidden={!ifAddToShoppingCart}>
                  {goods && goods.integral != '2' && (
                    <div
                      style={convertLineStyleData('background:' + storeStyle.theme)}
                      className="pay-add-to-shoppingcart"
                      onClick={this.sureAddToShoppingCart}
                    >
                      加入购物车
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/presell-detail/PresellDetail.jsx